import {equals} from 'ramda'
import {BrandType} from 'brand/types'

export const CAREERS_LINK = 'https://careers.findhotel.net/'

/**
 * Generates, depending on the brand provided, a link to the About Us page for the given brand.
 * @param brand object with brand information.
 * @returns An HTML link
 */
export const generateAboutUsLink = (brand: BrandType): string => {
  return brand.code === 'findhotel'
    ? 'https://findhotel.kustomer.help/en_us/about-us-H1NZxHQO'
    : `https://support.etrip.net/about-us-rk8jmU2TO`
}

/**
 * Generates, depending on the brand provided, a link to the Privacy Policy page for the given brand.
 * @param brand object with brand information.
 * @returns An HTML link
 */
export const generatePrivacyPolicyLink = (brand: BrandType): string => {
  return brand.code === 'findhotel'
    ? 'https://findhotel.kustomer.help/en_us/privacy-policy-S1DZWxHQO'
    : `https://support.etrip.net/privacy-policy-SyCySYUkK`
}

/**
 * Generates, depending on the brand provided, a link to the Terms of Use page for the given brand.
 * @param brand object with brand information.
 * @returns An HTML link
 */
export const generateTermsOfUseLink = (brand: BrandType): string => {
  return brand.code === 'findhotel'
    ? 'https://findhotel.kustomer.help/en_us/terms-of-use-BJ8bbxBX_'
    : `https://support.etrip.net/terms-of-use-S1zF4YI1t`
}

/**
 * Generates, depending on the brand provided, a link to the Help page for the given brand.
 * @param brand object with brand information.
 * @returns An HTML link
 */
export const generateHelpLink = (brand: BrandType): string => {
  return brand.code === 'findhotel'
    ? 'https://findhotel.kustomer.help/'
    : `https://support.etrip.net/`
}

/**
 * Generates, depending on the brand provided, a link to the Contact page for the given brand.
 * @param brand object with brand information.
 * @returns An HTML link
 */
export const generateContactLink = (brand: BrandType): string => {
  return brand.code === 'findhotel'
    ? 'https://findhotel.paperform.co'
    : 'https://etrip.paperform.co'
}

/**
 * Each brand uses a different code, this function determines if the brand
 * is FindHotel by checking the code.
 * @param code The brand Code
 * @returns true when brand is FH
 */
export const isFindHotelBrand = (code: BrandType['code']) =>
  equals(code, 'findhotel')
